$.ready(function() {
	var panel = game.panel = $.div('panel').apply('panel', { game: game }).appendTo(game);
	
	/* Overrides */
	/* globals base spinClear */
	{
		panel.setBet = function(values) {
			for (var key in values) {
				if (!this[key]) {
					continue;
				}
				
				this[key].set(values[key]);
			}
		};
		
		panel.getBet = function() {
			var bet = {
				denom: panel.denom.get(),
				coins: panel.coins.get(),
			};
			
			if (game.pays.type === 'lines') {
				bet.lines = panel.lines.get();
			}
			
			game.trigger('bet', bet);
			
			return bet;
		};
	}
	
	/* Play Button */
	{
		panel.spin = $.div().apply('widget', { label: 'Spin', value: true }).addClass('meter');
		
		panel.spin.scale = function() {
			if (panel.isCash) {
				this._scale = 1 / panel.denom.get();
			}
			
			else {
				this._scale = false;
			}
			
			return this.update();
		};
		
		panel.spin.update = function() {
			var bet = panel.getBet();
			delete bet.denom;
			
			var cost = game.pays.cost || 1;
			
			var key;
			
			for (key in bet) {
				if (key.substr(-5) === '_cost') {
					continue;
				}
				
				if (typeof bet[key] === 'number') {
					cost *= bet[key];
				}
			}
			
			for (key in bet) {
				if (key.substr(-5) !== '_cost') {
					continue;
				}
				
				if (typeof bet[key] === 'number') {
					cost += bet[key] * bet.coins;
				}
			}
			
			if (typeof this._scale === 'number') {
				game.panel.spin.set($.plugins.meter.__format(cost / this._scale, false));
			}
			
			else {
				game.panel.spin.set($.plugins.meter.__format(cost));
			}
		};
		
		if (panel.type === 'desktop') {
			panel.registerCash(panel.spin);
			
			panel.play.addClass('base');
			panel.spin.appendTo(panel.play);
		}
		
		if (panel.type === 'mobile') {
			panel.play.addClass('icon-spin');
			panel.registerCash(panel.spin, true);
			panel.spin.label.html('Bet');
			
			panel.spin.on('click', function() {
				if (game.panel.disabled) {
					return;
				}
				
				game.panel.dialog.show(game.panel.bet);
				game.panel.hud.hide();
			});
			
			panel.addItem(panel.spin, 'bottom middle');
		}
	}
	
	/* Betting */
	{
		if (panel.type === 'desktop') {
			panel.lines = $.div().apply('counter', { label: 'Pays' });
			panel.addItem(panel.lines, 'left');
			panel.lines.on('update', function() {
				panel.spin.update();
				
				game.pays.clear(true, true);
				game.pays.drawLines(this.get());
				
				game.sounds.play([ 'buttons', 'lines', 'line_' + this.value ]);
			});
			
			panel.coins = $.div().apply('counter', { label: 'Bet Per' });
			panel.addItem(panel.coins, 'right');
			panel.coins.on('update', function() {
				panel.spin.update();
				let betSound = this.value;
				
				while ( !game.sounds.fallback && !game.sounds.sounds.buttons.coins['bet_' + betSound]) {
					betSound--;
				}
				
				game.sounds.play([ 'buttons', 'coins', 'bet_' + betSound ]);
			});
			
			panel.denom = $.div().apply('counter', { label: 'Denom', menu: 'small' });
			panel.denom.max = null;
			panel.addItem(panel.denom, 'right far');
			panel.denom.on('update', function() {
				panel.spin.update();
				panel.updateCash();
				
				game.sounds.play([ 'buttons', 'denoms', 'denom_' + this.value ]);
			});
			
			panel.denom.addClass('denom cash');
			panel.denom.field.addClass('cash');
			panel.denom.on('reset', function() {
				for (var i = 0; i < this.items.length; i++) {
					this.items[i].label.addClass('cash');
				}
			});
			
			panel.max = $.div().apply('button', { label: 'Max' });
			panel.addItem(panel.max, 'right mini');
			panel.max.on('click', function() {
				if (game.panel.disabled) {
					return;
				}
				
				panel.coins.max();
				panel.lines.max();
				game.sounds.play([ 'buttons', 'max' ]);
			});
		}
		
		if (panel.type === 'mobile') {
			panel.lines = $.div().apply('roller', { label: 'Pays' });
			panel.addItem(panel.lines, 'bet');
			panel.lines.on('update', function() {
				panel.spin.update();
				
				game.pays.clear(true, true);
				game.pays.drawLines(this.get());
				game.sounds.play([ 'buttons', 'lines', 'line_' + this.value ]);
			});
			
			panel.coins = $.div().apply('roller', { label: 'Coins' });
			panel.addItem(panel.coins, 'bet');
			panel.coins.on('update', function() {
				panel.spin.update();
				game.sounds.play([ 'buttons', 'coins', 'bet_' + this.value ]);
			});
			
			panel.denom = $.div().apply('roller', { label: 'Denom' });
			panel.denom.max = null;
			panel.addItem(panel.denom, 'bet');
			panel.denom.on('update', function() {
				panel.spin.update();
				panel.updateCash();
				game.sounds.play([ 'buttons', 'denoms', 'denom_' + this.value ]);
			});
			
			panel.denom.addClass('cash');
			panel.denom.on('reset', function() {
				for (var i = 0; i < this.items.length; i++) {
					this.items[i].label.addClass('cash');
				}
			});
		}
	}
	
	/* Events */
	
	panel.on('play', function() {
		if (!game.feature.active || game.feature.active === 'freespin') {
			if (game.autoplay.isActive()) {
				game.autoplay.set(0);
				
				return;
			}
			
			game.spindle.stop = -1;
			
			if (!panel.win.isReady() || game.last && game.last.doubleRollup) {
				panel.setWin(true);
				game.trigger('slamPays');
				return;
			}
		}
		
		game.play();
	});
	
	panel.on('slam', function() {
		if (!game.feature.active || game.feature.active === 'freespin') {
			if (game.autoplay.isActive()) {
				game.autoplay.set(0);
				
				return;
			}
			
			game.spindle.stop = -1;
			
			if (!panel.win.isReady()) {
				panel.setWin(true);
				game.trigger('slamPays');
				return;
			}
		}
		
		if (game.feature.active && game.panel.state === game.feature.active) {
			game.features[game.feature.active].trigger('play');
			
			return;
		}
	});
	
	panel.dialog.on('hide', function(e) {
		if (!e.detail) {
			return;
		}
		
		if (e.detail.slug === 'credits') {
			spinClear();
			panel.enable();
		}
	});
	
	panel.win.on('done', function() {
		panel.setCredits(game.last.credits);
		
		if (game.feature.active) {
			game.sounds.fade([ game.feature.active, 'background' ], 0, 1, 1.5);
		}
		
		else {
			game.sounds.fade([ 'background' ], 0, 1, 0.5);
		}
		
		if(game.last.doubleRollup) {
			return;
		}
		
		game.trigger('round_complete');
	});
	
	game.controller.socket.on('spin', function(response) {
		panel.setCredits(response.credits - (response._win || 0));
	});
	
	game.on('ui', function(config) {
		config = config.detail;
		
		panel.setCredits(config.credits);
		
		panel.coins.reset(config.bet.bets, 0);
		
		if (config.lines) {
			panel.lines.label.html('Lines');
			panel.lines.reset(config.bet.lines, -1);
		}
		
		else if (config.ways) {
			var ways = 0;
			if (config.rows.constructor === Array) {
				ways = config.rows.reduce(function(rows, reel) {
					return rows * reel;
				}, 1);
			}
			else {
				ways = Math.pow(config.rows, config.reels);
			}
			
			panel.lines.label.html('Ways');
			panel.lines.reset([ ways ], -1);
		}
		
		var denoms = [];
		
		for (var d = 0; d < config.bet.denoms.length; d++) {
			denoms.push($.plugins.meter.__format(config.bet.denoms[d], false));
		}
		
		panel.denom.reset(config.bet.denoms, 0, denoms);
		
		game.pays.clear();
	});
	
	game.on('ready', function() {
		if (!panel.state) {
			panel.enable();
		}
	});
});



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/plugins/slot/public-src/common/js/panel.js
 **/